import { FC, useState, useEffect } from 'react';
import clsx from 'clsx';

import Card from './Card/Card';
import CompactCard from './CompactCard/CompactCard';

import styles from './List.module.scss';
import { ImageResponseType } from '../../../../../types/base';
import Compact from '../../../../Icons/Compact';
import Cards from '../../../../Icons/Cards';
import { ICardProps as IFavorites } from '../../../FavoritesPage/components/Card/Card';

export interface ICardProps {
  article_number?: string;
  cmmf: string;
  commercial_number?: string;
  name: string;
  brand: {
    name: string;
    image?: ImageResponseType;
  };
  category: {
    name: string;
    image?: ImageResponseType;
  };
  status?: string | null;
  count?: number | null;
  type: string;
  image: ImageResponseType;
  replaceBy?: any[] | null;
  replaceFor?: any[] | null;
  in_stoke: boolean;
  model?: string;
  isExtra?: boolean;
  id: string;
  slug: string;
}

export interface IListProps {
  data: {
    count: string | number;
    showCount: string;
    items: ICardProps[];
    favorites: IFavorites[];
  };
}

const List: FC<IListProps> = ({ data }) => {
  const [view, setView] = useState('compact'); // cards
  useEffect(() => {
    const resizeFunc = () => {
      if (window.innerWidth < 1024) setView('cards');
    };
    window.addEventListener('resize', resizeFunc);
    resizeFunc();
    return () => window.removeEventListener('resize', resizeFunc);
  }, []);
  return (
    <div className={styles.List}>
      <div className={styles.header}>
        <span>
          {data.showCount} из {data.count}
        </span>
        <div className={styles.view_btns}>
          <button
            className={clsx({ [styles.active]: view === 'compact' })}
            onClick={() => setView('compact')}
          >
            <Compact />
          </button>
          <button
            className={clsx({ [styles.active]: view === 'cards' })}
            onClick={() => setView('cards')}
          >
            <Cards />
          </button>
        </div>
      </div>
      <div
        className={clsx(styles.content, {
          [styles.compact]: view == 'compact',
        })}
      >
        {view == 'cards' ? (
          data.items.map((item, index) => (
            <Card data={item} key={index} favorites={data.favorites} />
          ))
        ) : (
          <>
            <div className={styles.table_header}>
              <span>Тип</span>
              <span>Артикул </span>
              <span>Комм. код</span>
              <span>Название</span>
              <span>Бренд</span>
              <span>Категория</span>
              <span>Статус</span>
              <span></span>
            </div>
            {data.items.map((item, index) => (
              <CompactCard data={item} key={index} favorites={data.favorites} />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default List;
